export default __webpack_public_path__ + "static/media/toggle.54cfd8ab.png";